var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-autocomplete", {
    ref: "places",
    staticClass: "soli-round",
    attrs: {
      label: "Address",
      id: "places",
      items: _vm.locationEntries,
      "search-input": _vm.locationSearchText,
      "prepend-inner-icon": "place",
      "item-text": "value",
      "item-value": "value",
      "error-messages": _vm.errors,
      "hide-no-data": "",
      outlined: "",
      dense: "",
      "validate-on-blur": "",
      "auto-select-first": "",
      rules: _vm.rules,
    },
    on: {
      "update:searchInput": function ($event) {
        _vm.locationSearchText = $event
      },
      "update:search-input": function ($event) {
        _vm.locationSearchText = $event
      },
      change: _vm.handleAddress,
    },
    model: {
      value: _vm.addressModel,
      callback: function ($$v) {
        _vm.addressModel = $$v
      },
      expression: "addressModel",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }